<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div ref="userDocsTab">
    <uploader-sidebar :isSidebarActive="sidebarActive" :studentId="studentId" @saveData="successUpload" @closeSidebar="sidebarActive = false" />
    <div ref="whole_page" class="vx-col w-full">
      <vs-button v-if="!monitorMode" color="success" type="filled" class="mb-2" @click="sidebarActive = true">Upload / Generate Document</vs-button>
      <div>
        <vs-table ref="uploadsTable" single max-items="5" pagination :data="uploadedFiles">
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="url">File Name</vs-th>
            <vs-th sort-key="documentTypeName">Document Type</vs-th>
            <vs-th sort-key="moduleName">Linked Module</vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
            <vs-th v-if="!monitorMode" ></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
              <vs-td>
                <img :src="setFileThumb(file.url)" width=30px class="product-img" />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1) }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.documentTypeName }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.moduleName ? file.moduleName : "None" }}</p>
              </vs-td>
              <vs-td>
                <vs-button v-if="file.documentTypeId != 9 && !monitorMode" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop.prevent="removeDoc(file.id)"></vs-button>
                <vs-button v-if="file.documentTypeId == 9" color="success" type="flat" icon-pack="feather" icon="icon-download" @click.stop="downloadLogbook(file.id)"></vs-button>
                <vs-button v-if="file.documentTypeId != 9 && monitorMode" color="success" type="flat" icon-pack="feather" icon="icon-download" @click.stop="open(file)"></vs-button>
              </vs-td>
              <vs-td v-if="!monitorMode">
                <vs-button :id="`preview-logbook-btn_${indextr}`" color="success" size="small" style="padding: 10px !important;" class="vs-con-loading__container" icon-pack="feather" icon="icon-eye" @click.stop.prevent="open(file)">Preview</vs-button>
              </vs-td>
              <vs-td>
                <!-- <vs-button v-if="file.documentTypeId == 9" color="success" size="small" class="vs-con-loading__container" @click="approveLogbook">Sign Logbook</vs-button> -->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <vs-divider class="mb-6 pt-0"></vs-divider>
    <div class="vx-row">
      <vs-spacer></vs-spacer>
      <div class="vx-col">
        <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#studentInfoCard'" @click="cancelAdd">Close</vs-button>
      </div>
    </div>

    <vs-popup
      id="logbook-preview-popup"
      title="Logbook Preview"
      :active.sync="isLogbookPreviewPopupActive"
      fullscreen
    >
      <div v-if="logbookHtml" class="vx-row">
        <div class="vx-col w-full">
          <div id="html-content" v-html="logbookHtml"></div>
          <div class="vx-row mt-3">
            <vs-spacer />
            <div class="vx-col">
              <vs-button ref="approve_logbook_btn" class="vs-con-loading__container" @click="approveLogbook" color="success">Sign Logbook</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup id="AssessorFeedbackDocument" fullscreen :button-close-hidden="true" title="Assessor Feedback Preview" :active.sync="assessorFeedbackPreviewPopup">
      <div class="assessorFeedbackSize" style="width: fit-content; margin:auto">
        <assessorFeedbackDocument  :assessorFeedbackData="assessorFeedbackData" :taskResults="taskResults" :questionList="questionList" :assessorFeedback="assessorFeedback" :isModerator="isModerator" @closeAssessorFeedbackDocument="closePopUp" />
      </div>
    </vs-popup>

    <vs-popup id="AssessorReportDocument" fullscreen :button-close-hidden="true" title="Assessor Report Preview" :active.sync="assessorReportDocumentPopup">
      <div class="assessorFeedbackSize" style="width: fit-content; margin:auto">
        <assessorReportDocument  :assessorReportData="assessorReportData" @moderatorQuestions="moderatorQuestions" />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import uploaderSidebar from './StudentDocUploadSidebar.vue';
import assessorFeedbackDocument from "../components/AssessorFeedbackDocument.vue";
import assessorReportDocument from "../components/AssessorReportDocument.vue";

export default {
  components: {
    assessorFeedbackDocument,
    vSelect,
    uploaderSidebar,
    assessorReportDocument
  },
  props: {
    studentId: {
      type: Number,
      required: true
    },
    monitorMode:{
      type:Boolean,
      required:false,
    }
  },
  data() {
    return {
      uploadedFiles: [],
      sidebarActive: false,
      isLogbookPreviewPopupActive: false,
      logbookHtml: "",
      selectedDocumentId: 0,
      assessorFeedbackPreviewPopup:false,
      assessorFeedbackData:{},
      taskResults:{},
      questionList:[],
      assessorFeedback:{},
      assessorFeedbackDocument:false,
      isModerator:false,
      assessorReportData:{},
      assessorReportDocumentPopup:false,
      assessorReportDocumentId:0,
      reviewQuestions:[],
      reviewHTML:"",
    }
  },
  watch: {
    studentId: function (val) {
      this.getDocuments();
    },
    isLogbookPreviewPopupActive: function (val) {
      if (!val) {
        this.logbookHtml = "";
      }
    }
  },
  methods: {
    getDocuments() {
      var self = this;

      if (self.$route.query.studentDocumentId) {
        self.showLoadingOnElement("whole_page", 1, "corners");
      } else {
        self.showLoadingOnElement("uploadsTable", 1, "corners");
      }

      var onSuccess = function(response) {
        self.uploadedFiles = response.data;

        if (self.$route.query.studentDocumentId) {
          setTimeout(() => {
            self.$vs.loading.close(self.$refs.whole_page.$el);
            var file = self.uploadedFiles.filter(x => x.id == self.$route.query.studentDocumentId)[0];
            self.open(file);
            self.$router.replace({'query': null});
          }, 100);
        }
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/GetDocs?id=" + self.studentId, onSuccess, onFinally);
    },
    open(file){
      if (file.url == "Logbook") {
        this.previewLogbook(file.id, file.studentId, file.moduleId);
        return;
      } 
      if(file.documentTypeId == 11 && file.signedByModeratorId == null && this.$acl.check("Moderator")){
        this.signFeedbackDocument(file.id);
        return;
      }
      if(file.documentTypeId == 12 && file.signedByModeratorId == null && this.$acl.check("Moderator")){
        this.openAssessorReport(file);
        return;
      }
        
      window.open(file.url);
      
    },
    successUpload(data) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");
      self.sidebarActive = false;
      var fileUrl = data.uploadedFileName;

      var onSuccess = response => {
      self.getDocuments();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Uploaded",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      var formData = {
        studentId: self.studentId,
        documentTypeId: data.documentTypeId,
        moduleId: data.moduleId,
        url: fileUrl
      }
      
      self.$ajaxPost(self, "Student/AddDoc", formData, onSuccess, onFinally);
    },
    removeDoc(id) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");

      var onSuccess = function(response) {
        self.getDocuments();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/RemoveDoc/" + id, onSuccess, onFinally);
    },
    downloadLogbook(fileId){
      var self = this;
        self.showLoadingOnElement("uploadsTable", 1, "corners");

        var onSuccess = response =>{
          window.open(response.data);
        }

        var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
        };

        self.$ajaxGet(self, "Logbook/GenerateLogbookPDF?logbookId=" + fileId, onSuccess, onFinally);
    },
    setFileThumb(url) {
      if (url == 'Logbook') {
        return "https://forty5degreesstorage.blob.core.windows.net/assets/logbook.png";
      } else {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      }
    },
    previewLogbook(documentId, studentId, moduleId) {
      const self = this;
      self.selectedDocumentId = documentId;
      self.showLoadingOnElement("userDocsTab", 1, "material");

      var onSuccess = function(response) {
        self.isLogbookPreviewPopupActive = true;
        self.logbookHtml = response.data;
      };
      var onFinally = (response) => {
        if (self.$refs.userDocsTab) {
          self.$vs.loading.close(self.$refs.userDocsTab.$el);
        }
      };

      self.$ajaxGet(self, `Logbook/GenerateLogbookPreview?userId=${studentId}&moduleId=${moduleId}`, onSuccess, onFinally);
    },
    approveLogbook() {
      const self = this;
      self.showLoadingOnElement("approve_logbook_btn", 0.45, "material");

      var onSuccess = function(response) {
        self.isLogbookPreviewPopupActive = false;
      };
      var onFinally = (response) => {
        if (self.$refs.approve_logbook_btn) {
          self.$vs.loading.close(self.$refs.approve_logbook_btn.$el);
        }
      };

      if (self.$acl.check("Assessor")) {
        self.$ajaxGet(self, `Assessor/AcceptLogbook/${self.selectedDocumentId}`, onSuccess, onFinally);
      } else if (self.$acl.check("Moderator")) {
        self.$ajaxGet(self, `Moderator/AcceptLogbook/${self.selectedDocumentId}`, onSuccess, onFinally);
      }
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    cancelAdd() {
      this.$emit("cancelAdd")
    },
    signFeedbackDocument(id){
      var self = this;
      self.showLoadingOnElement("userDocsTab",1,"corners");

      var onSuccess = response =>{
        this.assessorFeedbackData = response.data;
        this.taskResults.fullname = response.data.learnerFullName;
        this.questionList = response.data.assessorFeedbackQuestionDTO;
        this.assessorFeedback = response.data.assessorFeedbackDTO;
        this.isModerator = true;
        this.assessorFeedbackPreviewPopup = true;
      }
    
      var onFinally = response =>{
        if(self.$refs.userDocsTab){
          self.$vs.loading.close(self.$refs.userDocsTab.$el);
        }
      }
    
      self.$ajaxGet(self, `assessorFeedback/Moderator/${id}` , onSuccess, onFinally);
    },
    closePopUp(){
      this.assessorFeedbackPreviewPopup = false;
      this.$emit("reload");
      this.$emit("cancelAdd");
    },
    openAssessorReport(file){
      var self = this;
      self.showLoadingOnElement("uploadsTable",1,"corners");

      var onSuccess = response =>{
        self.assessorReportData = response.data;
        self.assessorReportDocumentPopup = true;
      }
    
      var onFinally = response =>{
        if(self.$refs.uploadsTable){
          self.$vs.loading.close(self.$refs.uploadsTable.$el);
        }
      }
      self.$ajaxGet(self, `assorreport/GetAssessorReportData?studentmoduleId=${file.studentModuleId}&documentId=${file.id}` , onSuccess, onFinally);
    },
    moderatorQuestions(fileId){
      var self = this;
      self.assessorReportDocumentPopup = false;
      self.assessorReportDocumentId = fileId;
      self.getReviewQuestions();
    },
    getReviewQuestions(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.reviewQuestions = response.data;
        self.varcReviewHtml();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `moderator/ReviewQuestions?documentId=${self.assessorReportDocumentId}` , onSuccess, onFinally);
    },
    varcReviewHtml(){
      var self = this;
      self.reviewHTML = "";
      for (let index = 0; index < self.reviewQuestions.length; index++) {
        self.reviewHTML += `
        <div class="Heading mb-3">
          <p><span>${self.reviewQuestions[index].questionId}. </span>${self.reviewQuestions[index].question}</p>
        </div>
        <div class="vx-row checkbox-relative">
          <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
            <input type="checkbox" class="check_container" checked id="varcccheck${self.reviewQuestions[index].questionId}">
            <div class="state p-success">
              <label for="varcccheck${self.reviewQuestions[index].questionId}"> Agree</label><br>
            </div>
          </div>
          <div class="vx-col w-2/3">
            <div class="vs-component vs-con-textarea vs-textarea-primary">
              <textarea placeholder="Description" id="varcccomment${self.reviewQuestions[index].questionId}" class="vs-textarea">${self.reviewQuestions[index].moderatorComment ? self.reviewQuestions[index].moderatorComment : ''}</textarea> 
            </div>
          </div>
        </div>
        `;
        self.lastIndex = index;
      };
      self.showpopupReview();
    },
    showpopupReview(){
      var self = this;
      self.$swal({
        title: 'Review of the Assessment',
        icon: 'info',
        html: `
        <h4>Answer the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.reviewHTML}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown varccs-evaluation',
        },
        confirmButtonText:'Complete',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 0; index < self.reviewQuestions.length ; index++) {
            var generatedCheckId = `varcccheck${self.reviewQuestions[index].questionId}`
            var generatedCommentId = `varcccomment${self.reviewQuestions[index].questionId}`
            var check = document.getElementById(generatedCheckId).checked;
            var comment = document.getElementById(generatedCommentId).value;
            self.reviewQuestions[index].moderatorResponse = check;
            self.reviewQuestions[index].moderatorComment = comment;
          }
        },
      }).then((result) => {
        self.returnReview();
      });
    },
    returnReview(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Signed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
        self.getDocuments();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        
      }
    
      self.$ajaxPost(self, `moderator/UpdateReviewAnswers?documentId=${self.assessorReportDocumentId}`, self.reviewQuestions , onSuccess, onFinally);
    },
  },
  mounted() {
    var self = this;
    self.getDocuments();
  }
}
</script>
<style lang="scss">
#logbook-preview-popup {
  * {
    color: #000000 !important;
  }
  .vs-popup {
    height: fit-content !important;
    background: #ffffff !important;
    color: #000000 !important;

    .vs-popup--content {
      overflow-x: hidden !important;
    }

    .vs-popup--header {
      background: #d8d8d8 !important;

      .vs-popup--close--icon {
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
}
.varccs-evaluation{
  width: 50% !important;
  .popupCustomContent{
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
</style>